/* Copyright (c) 2020-present CloudIO Inc */

import { Platform } from '../../platform/Platform';
import { baseComponentManager } from '../../registry/Components';
import {
  ComponentManagerFn,
  PropertyDefinitions,
} from '../../registry/Component.type';
import { ItemType } from '../../registry/ComponentRegistry';
import { defaultValue, DropTarget } from './DropTarget';
import { CommonProps } from '../../layout/Sidebar/panels/PropertiesView/CommonProperties';

export const DropTargetProps: PropertyDefinitions<
  Omit<DropTarget, keyof CommonProps>
> = {
  type: {
    label: 'Type',
    type: 'string',
    helpText:
      'You can specify a type value for this drop target. Only the Drag Sources with the same type can be dropped on this.',
    required: true,
  },
  canDropCondition: {
    label: 'Can Drop Condition',
    type: 'expressionOnly',
    returnType: () => 'boolean',
  },
  canDrop: {
    label: 'canDrop Function',
    type: 'controllerFunction',
    category: 'Controllers',
  },
  onDrop: {
    label: 'onDrop Function',
    type: 'controllerFunction',
    category: 'Controllers',
  },
};

const DropTargetManager: ComponentManagerFn<'DropTarget'> = (
  platform: Platform,
) => {
  return {
    ...baseComponentManager<'DropTarget'>(platform, 'DropTarget'),
    type: 'DropTarget',
    name: 'Drop Target',
    isChildAllowed: (page, item, childType) =>
      (['Card', 'RowPanel', 'TriggerOnDrop'] as ItemType[]).includes(childType),
    defaultValue,
    props: DropTargetProps,
    canHaveChildren: () => true,
    // getDisplayText: (item) => item.props.icon?.iconName ?? 'Choose icon!',
    category: 'Containers',
    icon: { iconName: 'expand-wide' },
    description:
      'Drop Target component used to bind it in a drop wrapper. This will allow drag source wrapper contents to be dropped inside it.',
  };
};

export default DropTargetManager;
